import type { InjectionKey } from 'vue';

import i18n from '@/i18n';
import { WorkerMissionStatus } from '@/types/mission';

import {
	type DropdownGeneratorAction,
	DropdownGeneratorActionType,
	DropdownItemColors,
} from '@/dsComponents/Dropdown/types';

export const workerStatusActionsSymbol: InjectionKey<
	(status: WorkerMissionStatus) => void
> = Symbol('WorkerStatusAction');

export const agencyWorkerStatusActionsList = (): (DropdownGeneratorAction & {
	statusName?: WorkerMissionStatus;
})[] => [
	{
		statusName: WorkerMissionStatus.PROPOSED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.agency.propose'
			),
		},
	},
	{
		statusName: WorkerMissionStatus.REPROPOSED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.agency.repropose'
			),
		},
	},
	{
		statusName: WorkerMissionStatus.REPROPOSED_BY_SMS,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.agency.repropSMS'
			),
		},
	},
	{
		statusName: WorkerMissionStatus.CONFIRMED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('global.actions.confirm'),
		},
	},
	{
		statusName: WorkerMissionStatus.NOT_CONFIRMED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.agency.notConfirm'
			),
			backGroundColor: DropdownItemColors.red,
		},
	},
	{
		statusName: WorkerMissionStatus.REJECTED_BY_AGENCY,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t('global.actions.cancel'),
			backGroundColor: DropdownItemColors.red,
		},
	},
];

export const workerStatusActionsList = (): (DropdownGeneratorAction & {
	statusName?: WorkerMissionStatus;
})[] => [
	{
		statusName: WorkerMissionStatus.ACCEPTED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.worker.accept'
			),
		},
	},
	{
		statusName: WorkerMissionStatus.DECLINED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.worker.reject'
			),
			backGroundColor: DropdownItemColors.red,
		},
	},
	{
		statusName: WorkerMissionStatus.ABORTED,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t(
				'modals.missionDetails.propositions.actions.worker.abort'
			),
			backGroundColor: DropdownItemColors.red,
		},
	},
];
